import { atom, map } from "nanostores"
import { queryClient } from "@/queries/client"

export const $isLaunchDarklyInitialized = atom<boolean>(false)

export const $launchDarklyFlags = map<Record<string, boolean | string>>({})

export const registerLaunchDarklyFlagUse = <T extends boolean | string>(
  flagKey: string,
  value: T
): T => {
  if (value !== $launchDarklyFlags.get()[flagKey]) {
    $launchDarklyFlags.setKey(flagKey, value)
  }

  return value
}

$launchDarklyFlags.subscribe(() => {
  console.log("LaunchDarkly flags updated", $launchDarklyFlags.get())

  // Cause a re-initialize of user identities..
  void queryClient.invalidateQueries({ queryKey: ["user"] })
})
